module.exports = __webpack_public_path__ + "img/aboutUsHomeCart3.9bc2185d.png";